module.exports = __webpack_public_path__ + "img/change.36573bd7.svg";